"use strict";
exports.__esModule = true;
exports.DefaultParams = void 0;
var utils_1 = require("./utils");
exports.DefaultParams = {
    hasher: "blake2",
    hue: { min: 0, max: 360 },
    saturation: { min: 70, max: 100 },
    lightness: { min: 45, max: 65 },
    variation: { min: 5, max: 20, enabled: true },
    shift: { min: 60, max: 300 },
    figureAlpha: { min: .7, max: 1.2 },
    light: { top: 10, right: -8, left: -4, enabled: true },
    createCanvas: utils_1.createCanvas
};
